<template>
  <div
    class="modal fade"
    id="manage-status"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog cascading-modal modal-lg">
      <div class="modal-content" style="width: 130% !important">
        <div class="modal-header">
          <h4 class="modal-title m-r-15" id="myLargeModalLabel">
            Manage Status Type
          </h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body mb-1 pt-2">
          <div class="row justify-content-end">
            <div class="col-1">
              <div class="text-right">
                <button
                  class="btn btn-success waves-effect mt-2 mb-2"
                  type="button"
                  data-toggle="modal"
                  id=""
                  data-target="#template-name"
                >
                  <i class="fas fa-plus fa-2x"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="dataTables_length">
              <span style="margin-right: 10px"
                ><label for="">Show </label>
              </span>
              <select
                v-model="pageSize"
                class="form-control form-control-sm"
                aria-label="Default select example"
                @change="pageChange(1)"
              >
                <option selected>50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>

              <span style="margin-left: 10px">
                <label for=""> Entries </label></span
              >
            </div>
            <div class="col-sm-12 col-md-6">
              <div id="clmtable1_filter" class="dataTables_filter">
                <label
                  >Search:<input
                    type="search"
                    class="form-control form-control-sm"
                    placeholder=""
                    aria-controls="clmtable1"
                /></label>
              </div>
            </div>
          </div>
          <table
            ref="statusTable"
            data-height="300"
            id="editable-datatable"
            class="table display table-bordered text-center table-striped no-wrap editable-table"
          >
            <thead class="thead-dark">
              <tr>
                <th>
                  Status Order
                  <span
                    ><button class="asc-desc-btn" @click="OrderByFunc(1)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th>
                  Status Name
                  <span
                    ><button class="asc-desc-btn" @click="OrderByFunc(2)">
                      ↑ ↓
                    </button></span
                  >
                </th>
                <th></th>
                <th>
                  Open / Closed
                  <span>
                    <button class="asc-desc-btn" @click="OrderByFunc(3)">
                      ↑ ↓
                    </button>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ts, index) in TaskStatuses" :key="index" class="step">
                <td>
                  <a
                    class="nav-link border-green"
                    data-toggle="tab"
                    href="#step01"
                    role="tab"
                  >
                    <span class="hidden-xs-down">
                      <span
                        style="margin-right: 7px"
                        @click="arrowUp(ts, index)"
                        class="btn-floating btn-sm btn-success up status-order"
                        ><i class="fas fa-arrow-up white-text"></i
                      ></span>
                      <span
                        style="margin: 2px"
                        @click="arrowDown(ts, index)"
                        class="btn-floating btn-sm btn-success down status-order"
                        id="down"
                        ><i class="fas fa-arrow-down white-text"></i
                      ></span>
                      <span v-if="9999 === ts.srNo"></span>
                      <span v-else>{{ ts.srNo }}</span>
                    </span>
                  </a>
                </td>
                <td>
                  <textarea
                    type="text"
                    maxlength="30"
                    class="trans-input"
                    v-model="ts.statusName"
                    @change="nameUpdate(ts)"
                  ></textarea>
                </td>
                <td>
                  <button
                    v-if="ts.isActive == 1"
                    type="button"
                    class="btn btn-danger task-status-Archive"
                    @click="archiveTaskStatusCheck(ts)"
                  >
                    Archive
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-success task-status-Archive"
                    @click="activeTaskStatusCheck(ts)"
                  >
                    Activate
                  </button>
                </td>
                <td>
                  <div class="col-lg-3 switchery-demo">
                    <label class="switch text-center">
                      <input
                        type="checkbox"
                        v-model="ts.closeTask"
                        @change="changeTaskStatus(ts)"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <nav aria-label="Page navigation" style="float: right">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
              <!--show pagination-->
              <li v-if="showPagesMin > 1">
                <button class="page-link" @click="pageChange(1)">1</button>
              </li>
              <li v-if="showPagesMin > 1">
                <button disabled class="page-link disabledColor">...</button>
              </li>
              <!--show pagination-->
              <li
                v-for="pageNum in pageNumber"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </span>
              </li>

              <!--show pagination-->
              <li v-if="pageNumber > 10 && pageNumber - 4 >= pageNumber">
                <button disabled class="page-link disabledColor">...</button>
              </li>
              <li v-if="pageNumber > 10 && pageNumber - 4 >= pageNumber">
                <button class="page-link" @click="pageChange(pageNumber)">
                  {{ pageNumber }}
                </button>
              </li>
              <!--show pagination-->
              <li class="page-item colorActive">
                <span v-if="pageNumber == pageNumber">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>

  <!-- Status Modal -->
</template>
<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";
export default {
  name: "TaskStatusTable",
  data() {
    return {
      loader: "",
      TaskStatuses: [],
      pageNumber: 1,
      pageSize: 50,
      totalRows: 0,
      showPagesMin: 1,
      showPagesMax: 5,
      orderBy: 1,
      orderDeAsc: false,
    };
  },
  methods: {
    async changeTaskStatus(ts) {
      var count = this.TaskStatuses.filter((x) => x.closeTask == true);
      if (count.length == 0) {
        ts.closeTask = true;
        this.errorToastUpd("one status must be closed.");
        return;
      }
      console.log(count);
      var myData = {
        DC: this.dummyComm,
        TaskStatus: ts,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/ChangeTaskCloseStatus",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.successToastUpd();
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.getTaskStatuses();
        });
      console.log();
    },
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.pageSize) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if (this.showPagesMax / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
      } else if (this.showPagesMin / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
        if (this.showPagesMax < 5) {
          this.showPagesMax = 5;
        }
      } else {
        this.showPagesMin = 1;
        this.showPagesMax = 5;
      }
      //show pagination
      this.getTaskStatuses();
    },
    OrderByFunc(orderBy) {
      if (orderBy == this.orderBy) {
        if (this.orderDeAsc == false) {
          this.orderDeAsc = true;
        } else {
          this.orderDeAsc = false;
        }
      } else {
        this.orderDeAsc = true;
      }
      this.orderBy = orderBy;
      this.getTaskStatuses();
    },
    async nameUpdate(statusName) {
      this.loader = this.$loading.show({
        container: this.$refs.statusTable,
        // Optional parameters
        color: "#03a9f3",
      });
      this.intDummyComm();
      const myData = {
        dc: this.dummyComm,
        TaskStatus: statusName,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/ChangeTaskStatusName",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.successToastUpd();
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.getTaskStatuses();
        });
      console.log(statusName);
    },
    async getTaskStatuses() {
      this.loader = this.$loading.show({
        container: this.$refs.statusTable,
        // Optional parameters
        color: "#03a9f3",
      });
      const myData = {
        dc: this.dummyComm,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        orderby: this.orderBy,
        orderDeAsc: this.orderDeAsc,
      };
      this.intDummyComm();
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTaskStatus",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.TaskStatuses = response.data;
            this.totalRows = this.TaskStatuses[0].total;
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    async arrowUp(ts, index) {
      if (index == 0 || ts.isActive == 0) {
        return;
      }

      const original = this.TaskStatuses[index];
      const change = this.TaskStatuses[index - 1];
      this.TaskStatuses[index - 1] = original;
      this.TaskStatuses[index] = change;
      this.TaskStatuses[index].srNo = original.srNo;
      this.TaskStatuses[index - 1].srNo = original.srNo - 1;
      this.ChangeTaskStatusesSrno(
        this.TaskStatuses[index],
        this.TaskStatuses[index - 1]
      );
    },
    async arrowDown(ts, index) {
      if (index >= this.TaskStatuses.length || ts.isActive == 0) {
        return;
      }
      const original = this.TaskStatuses[index];
      const change = this.TaskStatuses[index + 1];
      this.TaskStatuses[index + 1] = original;
      this.TaskStatuses[index] = change;
      this.TaskStatuses[index].srNo = original.srNo;
      this.TaskStatuses[index + 1].srNo = original.srNo + 1;
      this.ChangeTaskStatusesSrno(
        this.TaskStatuses[index],
        this.TaskStatuses[index + 1]
      );
    },
    async ChangeTaskStatusesSrno(ts1, ts2) {
      this.loader = this.$loading.show({
        container: this.$refs.statusTable,
        // Optional parameters
        color: "#03a9f3",
      });
      this.intDummyComm();
      const myData = {
        dc: this.dummyComm,
        TaskStatusOg: ts1,
        TaskStatusCh: ts2,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/ChangeTaskStatusSrno",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.successToastUpd();
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.getTaskStatuses();
        });
    },
    activeTaskStatusCheck(ts) {
      Swal.fire({
        title: "You are about to activate a task status .",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "ok",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire({
            title: "Are you sure?",
            text: "This can't be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, activate this!",
            confirmButtonColor: "#dd6b55",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              //call delete api here
              this.activeTaskStatus(ts);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    async activeTaskStatus(ts) {
      this.intDummyComm();
      const myData = {
        dc: this.dummyComm,
        TaskStatus: ts,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/ActiveTaskStatus",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.successToastUpd();
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.getTaskStatuses();
        });
    },
    archiveTaskStatusCheck(ts) {
      Swal.fire({
        title: "You are about to archive a task status .",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "ok",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire({
            title: "Are you sure?",
            text: "This can't be undone",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Archive this!",
            confirmButtonColor: "#dd6b55",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              //call delete api here
              this.archiveTaskStatus(ts);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    async archiveTaskStatus(ts) {
      this.intDummyComm();
      const myData = {
        dc: this.dummyComm,
        TaskStatus: ts,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/ArchiveTaskStatus",
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.status === true) {
            this.successToastUpd();
          } else {
            this.showErrorToast("Unable To Create Task.", 4000);
          }
        })
        .finally(() => {
          this.getTaskStatuses();
        });
    },
  },
  mounted() {
    this.getTaskStatuses();
  },
};
</script>
<style scoped>
.trans-input {
  text-align: center;
  background: transparent;
  border: none;
  width: 100%;
}
</style>